"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useRenderTypingIndicator;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useRenderTypingIndicator() {
  return (0, _useWebChatAPIContext.default)().typingIndicatorRenderer;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VSZW5kZXJUeXBpbmdJbmRpY2F0b3IudHMiXSwibmFtZXMiOlsidXNlUmVuZGVyVHlwaW5nSW5kaWNhdG9yIiwidHlwaW5nSW5kaWNhdG9yUmVuZGVyZXIiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFDQTs7OztBQUVlLFNBQVNBLHdCQUFULEdBQTJEO0FBQ3hFLFNBQU8scUNBQXVCQyx1QkFBOUI7QUFDRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgUmVuZGVyVHlwaW5nSW5kaWNhdG9yIH0gZnJvbSAnLi4vdHlwZXMvVHlwaW5nSW5kaWNhdG9yTWlkZGxld2FyZSc7XG5pbXBvcnQgdXNlV2ViQ2hhdEFQSUNvbnRleHQgZnJvbSAnLi9pbnRlcm5hbC91c2VXZWJDaGF0QVBJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVJlbmRlclR5cGluZ0luZGljYXRvcigpOiBSZW5kZXJUeXBpbmdJbmRpY2F0b3Ige1xuICByZXR1cm4gdXNlV2ViQ2hhdEFQSUNvbnRleHQoKS50eXBpbmdJbmRpY2F0b3JSZW5kZXJlcjtcbn1cbiJdfQ==